import { isValidImageSrc } from '@/app/utils/isValidImageSrc';

/**
 * Adds optimization query parameters to an image URL for non-Next.js contexts
 * (e.g. Google Maps marker icons, canvas) where the Image loader isn't used.
 */
export function optimizeImageUrl(
  src: string,
  options: { width?: number; quality?: number } = {}
): string {
  const { width = 1080, quality = 75 } = options;

  if (!isValidImageSrc(src)) return '';

  try {
    const url = new URL(src);
    url.searchParams.set('w', width.toString());
    url.searchParams.set('q', quality.toString());
    url.searchParams.set('ext', 'webp');
    return url.toString();
  } catch {
    const separator = src.includes('?') ? '&' : '?';
    const params = new URLSearchParams({
      w: width.toString(),
      q: quality.toString(),
      ext: 'webp',
    });
    return `${src}${separator}${params.toString()}`;
  }
}
